import { startTransition, StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import * as Sentry from "@sentry/react";
import { initAnalytics } from "./utils/analytics";

// GlitchTip (Sentry-compatible) — production only, browser only. Unchanged from
// the previous client entry; moved here so it runs once on hydration.
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: "https://d87ffd01e6fc4ea19f4287fc571b0543@glitchtip.gazar.dev/1",
    tracesSampleRate: 0.01,
    denyUrls: [
      /^chrome-extension:\/\//i,
      /^moz-extension:\/\//i,
      /^safari-(web-)?extension:\/\//i,
      /apis\.google\.com\/js\/client\.js/i,
    ],
    ignoreErrors: [
      /Jsloader error/i,
      /_gapiProviderCallback_/i,
      // Injected by in-app browsers (LinkedIn, Instagram, Facebook) into pages they
      // frame. `sendDataToNative` is their bridge, not ours, and it throws whenever
      // the WebKit handler it expects is absent. Nothing on gazar.dev calls it.
      /webkit\.messageHandlers/i,
      /sendDataToNative/i,
    ],
  });
}

initAnalytics();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
